import api from "./api";

export const getPosts = async (topicId) => {
    try {
        const response = await api.get(`/posts/topics/${topicId}/`); // Ensure the correct endpoint
        return response.data;
    } catch (error) {
        console.error("Failed to fetch posts:", error);
        throw error;
    }
};

export const createPost = async (postData) => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("No access token found");
    }
    try {
        const isFormData = typeof FormData !== "undefined" && postData instanceof FormData;
        const response = await api.post("posts/", postData, {
            headers: isFormData ? { "Content-Type": "multipart/form-data" } : undefined,
        });
        return response.data;
    } catch (error) {
        // 讓 axios interceptor 處理 401 錯誤和 token refresh
        throw error;
    }
};

export const getUserPosts = async () => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("No access token found");
    }
    try {
        const response = await api.get("users/me/posts/");
        return response.data;
    } catch (error) {
        // 讓 axios interceptor 處理 401 錯誤和 token refresh
        throw error;
    }
};

export const getUserData = async () => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("No access token found");
    }
    try {
        const response = await api.get("users/me/");
        return response.data;
    } catch (error) {
        // 讓 axios interceptor 處理 401 錯誤和 token refresh
        throw error;
    }
};

export const uploadImage = async (imageFile) => {
    const formData = new FormData();
    formData.append("image", imageFile);

    try {
        const response = await api.post("posts/upload-image/", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        if (!response.data.url) {
            throw new Error("未返回有效的圖片 URL");
        }
        return response.data.url;
    } catch (error) {
        console.error("Failed to upload image:", error.response?.data || error.message);
        throw new Error("上傳圖片失敗，請稍後重試");
    }
};

export const getPost = async (postId) => {
    try {
        const response = await api.get(`posts/${postId}/`);
        return response.data;
    } catch (error) {
        console.error("Failed to fetch post:", error);
        throw error;
    }
};

export const likePost = async (postId) => {
    return await api.post(`posts/${postId}/like/`); // 確保返回 Axios 的 Promise
};

export const unlikePost = async (postId) => {
    return await api.delete(`posts/${postId}/unlike/`); // 確保返回 Axios 的 Promise
};
export const getPostLikesStatus = async (postId) => {
    return await api.get(`posts/${postId}/likes-status/`); // 確保返回 Axios 的 Promise
};

export const deletePost = async (postId) => {
    return await api.delete(`posts/${postId}/delete/`);
};

// Post tracking functions
export const trackPostView = async (postId, sessionId, clickedFrom) => {
    try {
        const response = await api.post(`posts/${postId}/track-view/`, {
            session_id: sessionId,
            clicked_from: clickedFrom
        });
        return response.data;
    } catch (error) {
        console.error("Failed to track post view:", error);
        throw error;
    }
};

export const updatePostDwellTime = async (postId, sessionId, dwellTime, scrollDepth) => {
    try {
        const response = await api.put(`posts/${postId}/update-dwell-time/`, {
            session_id: sessionId,
            dwell_time: dwellTime,
            scroll_depth: scrollDepth
        });
        return response.data;
    } catch (error) {
        console.error("Failed to update dwell time:", error);
        throw error;
    }
};

// 獲取熱門貼文
export const getHotPosts = async (limit = 10, topicId = null) => {
    try {
        const params = new URLSearchParams();
        params.append('limit', limit.toString());
        
        if (topicId) {
            params.append('topic_id', topicId.toString());
        }
        
        const response = await api.get(`posts/hot/?${params.toString()}`);
        
        // 確保返回的資料是陣列格式
        const results = Array.isArray(response.data) ? response.data : 
                       (response.data && Array.isArray(response.data.results)) ? response.data.results : [];
                       
        return {
            success: true,
            results: results
        };
    } catch (error) {
        console.error("Failed to fetch hot posts:", error);
        return {
            success: false,
            error: error.message || "無法載入熱門貼文"
        };
    }
};
